import type { FC } from 'react'

import type { HeroDto } from '@hcr/api/optimizely'
import { CardVariant, unit } from '@hcr/ui'

import { useHomeQuery } from '../../hooks/api/optimizely/queries'
import { createHomeContent } from '../../utils/api/optimizely/views'
import { BookingOverviewDestinationHome } from '../common/booking-overview/booking-overview-destination-home'
import { LayoutNavigationError500 } from '../common/layout-navigation'

import { HeaderHome, LayoutHome } from './common'
import { HomeDestinationLoading } from './HomeDestinationLoading'

const homeContent = createHomeContent({ slidesMargin: unit(3), variant: CardVariant.Regular })

interface HomeDestinationProps {
  hero: HeroDto
}

export const HomeDestination: FC<HomeDestinationProps> = ({ hero }) => {
  const home = useHomeQuery({ isAuthenticated: true })

  if (home.isError) {
    return <LayoutNavigationError500 />
  }

  if (home.isSuccess) {
    return (
      <LayoutHome
        imageUrl={hero.imageUrl}
        header={<HeaderHome />}
        content={home.data.content.map(homeContent)}
        bookingOverview={<BookingOverviewDestinationHome />}
      />
    )
  }

  return <HomeDestinationLoading />
}
